<nav class="navbar navbar-expand-lg px-3 py-2 header-container custom-navbar">
  <div class="header-wrapper container-fluid px-0">
    <div class="header-content d-flex w-100 align-items-center justify-content-between">
      <div class="header-container__left d-flex align-items-center">
        <a class="navbar-brand d-flex align-items-center" routerLink="/">
          <div class="logo-wrapper position-relative d-inline-block">
            <img src="assets/images/logo.png" alt="Company Logo" class="img-fluid me-1 main-logo" style="height: 50px;">
            <span class="trademark-symbol main-logo">™</span>
          </div>
        </a>
        <h5 class="mb-0 ms-2 main-name" style="padding: 0 !important;">Titanium Comms™</h5>
      </div>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain"
              aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse dropdown-collapse header-container__right" id="navbarMain">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item" *ngIf="!isHome">
            <a class="nav-link btn btn-blue"
               [routerLink]="['/']"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{ exact: true }">Home</a>
          </li>

          <li class="nav-item">
            <a class="nav-link btn btn-blue"
               [routerLink]="['/benefits']"
               routerLinkActive="active">Benefits</a>
          </li>

          <li class="nav-item">
            <a class="nav-link btn btn-blue"
               [routerLink]="['/about-us']"
               routerLinkActive="active">About QRE</a>
          </li>

          <!-- NEWS: parent <li> becomes .active when any child route is active -->
          <li class="nav-item dropdown"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }">
            <a class="nav-link btn btn-blue" href="#" id="navbarNews" role="button"
               data-bs-toggle="dropdown" aria-expanded="false">
              News
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarNews">
              <li><a class="dropdown-item" [routerLink]="['/news']">Industry News</a></li>
              <li><a class="dropdown-item" [routerLink]="['/newsquantum']">Quantum in the News</a></li>
              <li><a class="dropdown-item" [routerLink]="['/media']">Titanium in the News</a></li>
            </ul>
          </li>

          <li class="nav-item">
            <a class="nav-link btn btn-blue"
               [routerLink]="['/cheat-sheet']"
               routerLinkActive="active">FAQ/User Guide</a>
          </li>

          <li class="nav-item">
            <a class="nav-link btn btn-blue" (click)="scrollToPlans()">Subscribe</a>
          </li>

          <!-- MANAGE: active on /login or /dashboard -->
          <li class="nav-item">
            <a class="nav-link btn btn-blue"
               [routerLink]="['/login']"
               [class.active]="isManageActive">Manage Account</a>
          </li>

          <li class="nav-item" *ngIf="isLoggedIn">
            <button class="nav-link btn btn-blue" type="button" (click)="logout()">Log out</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
